window.addEventListener('scroll',()=>{
    //console.log(window.scrollY);
    if(window.scrollY > 400){
        document.getElementsByClassName('ToTop')[0].classList.add('is-scrolled');
    }else{
        document.getElementsByClassName('ToTop')[0].classList.remove('is-scrolled');
    }
})